import { render, staticRenderFns } from "./BbeeProductosServiciosC.vue?vue&type=template&id=6ce24d2d"
import script from "./BbeeProductosServiciosC.vue?vue&type=script&lang=js"
export * from "./BbeeProductosServiciosC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports